const url = {
    dev: {
        publicUrl: 'https://sentinel.api.zd-aichong.com/api',
        manageUrl: 'https://sentinel.api.zd-aichong.com/api'
    },
    pro: {
        publicUrl: 'https://sentinel.api.zd-aichong.com/api',
        manageUrl: 'https://sentinel.api.zd-aichong.com/api'
    }
}

export const get = () => {
    if(process.env.NODE_ENV === 'production'){
        return url['pro']
    }else{
        return url['dev']
    }
}
